module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "edit"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.listVideoQuery.orgLogo),
      callback: function($$v) {
        _vm.$set(_vm.listVideoQuery, "orgLogo", $$v)
      },
      expression: "listVideoQuery.orgLogo"
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "mt10",
    attrs: {
      "span": 10
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "file-list": _vm.fileList2,
      "action": _vm.domain,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.form,
      "on-success": _vm.handleAvatarSuccess,
      "list-type": "picture",
      "limit": 1,
      "multiple": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.upPicName = 'orgLogo'
      }
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，且不超过500kb")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-54d407c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/400.vue
// module id = 1663
// module chunks = 0